export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./matchWorks.vue?vue&type=template&id=6c51dfe1&"


//////////////////
// WEBPACK FOOTER
// ./src/views/match/matchWorks.vue?vue&type=template&id=6c51dfe1&
// module id = null
// module chunks = 